import api from '@/api/user/user';
import router from '@/router';
import { Message } from 'iview';
import { arrChangeOne2, setIconTitle, getTenantId } from '@/utils/util';
import { setStorage, clearStorage } from '@/utils/storage';
import vue from '@/main';
import store from '@/store';
import visitor from '@/api/Personnel/visitor';

const {
  login,
  validateTenantId,
  iconTitle,
  getUserInfo,
  getUserApplication,
  getUserMenu,
  switchToProxy,
  switchToSelf,
  getAccessToken,
  loginOut,
  getEmailToken,
  recordingLog,
  visitorToken,
} = api;
const user = {
  namespaced: true,
  state: {
    access_token: '',
    tenantId: '',
    userInfo: {},
    userApplication: {},
    userMenu: [],
    logoutStatus: false, // 是否退出登录
    proxyId: '',
    iconTitleData: {
      platformName: '2175云',
      copyrightName: '',
    },
  },
  mutations: {
    updateState(state, payload) {
      Object.assign(state, payload);
    },
    clearToken(state) {
      Object.assign(state, {
        access_token: '',
        userInfo: '',
        userApplication: {},
      });
      clearStorage();
    },
  },
  actions: {
    setLang() {
      let lang;
      if (localStorage.getItem('lang') === null) {
        let navLang = navigator.language; // 判断除IE外其他浏览器使用语言
        if (!navLang) {
          // 判断IE浏览器使用语言
          navLang = navigator.browserLanguage;
        }
        lang = navLang === 'zh-CN' ? 'cn' : 'en';
        localStorage.setItem('lang', lang);
      }
    },
    // 验证tenantId
    async validateTenantId({ commit, dispatch }, tenantId) {
      dispatch('setLang');
      const res = await validateTenantId(tenantId);
      if (res && res.data) {
        localStorage.tenantId = tenantId;
        let iconTitleData = {};
        if (!store.state.user.iconTitleData.tenantId) {
          let res = await iconTitle(getTenantId());
          if (res) {
            //icon图片地址具有时限性
            // sessionStorage.iconTitleData=JSON.stringify(res.data)
            iconTitleData = res.data;
          }
          setIconTitle(iconTitleData);
          store.commit('user/updateState', {
            iconTitleData,
          });
        }
        commit('updateState', {
          tenantId,
        });
        localStorage.setItem('logoUrl', res.data);
        return true;
      }
      return false;
    },
    // 候选人获取临时token
    async getAccessToken({ commit }, obj) {
      const res = await getAccessToken(obj);
      if (res) {
        commit('updateState', {
          access_token: res.data.access_token,
        });
      }
    },
    // 访客获取临时token
    async getVisitorToken({ commit }, obj) {
      const res = await visitorToken(obj);
      if (res) {
        commit('updateState', {
          access_token: res.data.access_token,
        });
      }
    },
    // 邮件获取临时token
    async getAccessTokenByEmail({ commit }, obj) {
      const res = await getEmailToken(obj);
      if (res) {
        commit('updateState', {
          access_token: res.data,
        });
        setStorage({
          access_token: res.access_token,
        });
      }
    },
    // 第三方免登录
    async getLoginDing({ state, commit, dispatch }, obj) {
      const res = await api[obj.api](obj);
      if (res) {
        commit('updateState', {
          access_token: res.data.access_token,
        });
        setStorage({
          access_token: res.data.access_token,
        });
        commit('updateState', {
          tenantId: obj.tenantId,
        });
        localStorage.setItem('tenantId', obj.tenantId);
        await dispatch('getUserInfo');
        await recordingLog();
        await dispatch('getUserApplication');
        await dispatch('getUserMenu');
        return true;
      }
      return false;
    },

    // 第三方免登录
    async getrecruitUrl({ state, commit, dispatch }, obj) {
      const res = await api.getrecruitToken();
      if (res) {
        const url = await api.getrecruitUrl({
          auth: res.data,
          key: '2175平台',
        });
        return url;
      }
      return false;
    },

    //魔学院跳转
    async getmoboUrl({ state, commit, dispatch }, obj) {
      const url = await api.getmoboUrl();
      return url;
    },
    // 登录
    async login({ state, commit, dispatch }, loginFormData) {
      dispatch('setLang');
      const res = await login({
        ...loginFormData,
        client_id: state.tenantId,
        client_secret: 'xxx',
        grant_type: 'password',
      });
      if (res && res.access_token) {
        commit('updateState', {
          access_token: res.access_token,
        });
        setStorage({
          access_token: res.access_token,
          roles: res.roles,
        });
        const userInfoRes = await dispatch('getUserInfo');
        await dispatch('getUserMenu');
        await recordingLog();
        const userApplicationRes = await dispatch('getUserApplication');
        if (userInfoRes && userApplicationRes) {
          localStorage.setItem('username', loginFormData.username);
          localStorage.setItem('tenantId', state.tenantId);

          const logo = await validateTenantId(localStorage.getItem('tenantId') || state.tenantId);
          if (logo) {
            localStorage.setItem('logoUrl', logo.data);
          }
          return true;
        }
        if (res && res.status) {
          Message.error(res.msg);
        }
        return false;
      }
      return false;
    },
    async switchToProxy({ commit }, userId) {
      const res = await switchToProxy({ user_id: userId });
      commit('updateState', {
        access_token: '',
      });
      setStorage({
        access_token: '',
      });
      if (res) {
        commit('updateState', {
          access_token: res.data.access_token,
        });
        setStorage({
          access_token: res.data.access_token,
        });
      }
    },
    async switchToSelf({ commit }, userId) {
      const res = await switchToSelf(userId);
      commit('updateState', {
        access_token: '',
      });
      setStorage({
        access_token: '',
      });
      if (res) {
        commit('updateState', {
          access_token: res.data.access_token,
        });
        setStorage({
          access_token: res.data.access_token,
        });
      }
    },
    // 退出登录
    async logout({ commit, state }) {
      if (state.userInfo && state.userInfo.user_name) await loginOut(state.userInfo.user_name);
      commit('updateState', {
        logoutStatus: true,
      });
      // //容联七陌
      // if(qimosdk){
      //   qimosdk.closeChatBox();
      // }
      commit('clearToken');
      setTimeout(() => {
        commit('updateState', {
          logoutStatus: false,
        });
        commit('clearToken');
        vue.$verifyPassword.remove();
        vue.$lutticaMessage.remove();
        vue.$Message.destroy();
        router.push({ name: 'login' });
      }, 2000);
    },
    // 初始化数据，获取登录用户信息
    async getUserInfo({ commit }) {
      const res = await getUserInfo();
      commit('updateState', {
        userInfo: {},
      });
      setStorage({
        userInfo: {},
      });
      if (res) {
        commit('updateState', {
          userInfo: res.data,
        });
        setStorage({
          userInfo: res.data,
        });
        localStorage.setItem('themeColor', res.data.bg_color);
        return true;
      }
      return false;
    },
    // 初始化数据，获取登录用户菜单项
    async getUserMenu({ commit }) {
      const res = await getUserMenu();
      if (res) {
        commit('updateState', {
          userMenu: res.data,
        });
        setStorage({
          userMenu: res.data,
        });
        const arr = arrChangeOne2(res.data).map(item => {
          return {
            title: item.title,
            href: item.href,
            icon: item.icon,
          };
        });
        setStorage({
          initUserMenu: arr,
        });
        const logo = await validateTenantId(localStorage.getItem('tenantId'));
        if (logo) {
          localStorage.setItem('logoUrl', logo.data);
        }
        let iconTitleData = {};
        if (!store.state.user.iconTitleData.tenantId) {
          let res = await iconTitle(getTenantId());
          if (res) {
            //icon图片地址具有时限性
            // sessionStorage.iconTitleData=JSON.stringify(res.data)
            iconTitleData = res.data;
          }
          setIconTitle(iconTitleData);
          store.commit('user/updateState', {
            iconTitleData,
          });
        }
        return true;
      }
      return false;
    },
    // 初始化数据，获取登录用户应用信息
    async getUserApplication({ commit }) {
      const res = await getUserApplication();
      if (res) {
        commit('updateState', {
          userApplication: res.data,
        });
        setStorage({
          userApplication: res.data,
        });
        return true;
      }
      return false;
    },
  },
};
export default user;
